import { useQuery } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import { type Meter } from "../utils/backend-types";
import { COMPONENT_QUERY_KEY } from "../utils/constants";
import { ObjectName } from "../utils/enums";

export function useMeters(siteId: number) {
  const cacheName = COMPONENT_QUERY_KEY[ObjectName.Meter];

  const { data, isLoading, error } = useQuery({
    queryKey: [cacheName, { siteOrVariantId: siteId }],
    queryFn: () => fetchMeters(siteId)
  });

  return { data, isLoading, error };
}

async function fetchMeters(siteId: number) {
  const response = await api.get<Array<Meter>>(urls.api.meters(siteId));
  return response.data;
}
